var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddressDelete = function SvgAddressDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "address-delete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h20v20H1z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Scroll Group 32",
    transform: "translate(-1 -1)",
    clipPath: "url(#address-delete_svg__a)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2627"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2622",
    fill: "none",
    stroke: "#e91f63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18610",
    d: "M17.216 8.532s-.469 5.841-.742 8.3a1.937 1.937 0 0 1-2.038 1.886c-2.255.041-4.513.043-6.768 0a1.916 1.916 0 0 1-1.979-1.875c-.274-2.482-.741-8.308-.741-8.308"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18611",
    d: "M18.417 5.777H3.75"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18612",
    d: "M15.584 5.777a1.424 1.424 0 0 1-1.394-1.148l-.21-1.055a1.106 1.106 0 0 0-1.068-.823H9.257a1.106 1.106 0 0 0-1.068.823l-.21 1.055a1.424 1.424 0 0 1-1.394 1.148"
  }))))));
};
export default SvgAddressDelete;